"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPowerBiFileModal = exports.title = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_bootstrap_1 = require("react-bootstrap");

var Loader_1 = __importDefault(require("../../layout/Loader"));

var Icon_1 = __importDefault(require("../../common/Icon"));

exports.title = 'Add a Power BI page';

var SelectPowerBiFileModal = function (_a) {
  var _b = _a.show,
      show = _b === void 0 ? true : _b,
      _c = _a.onHide,
      onHide = _c === void 0 ? function () {} : _c,
      _d = _a.fileSelected,
      fileSelected = _d === void 0 ? function () {} : _d,
      project = _a.project,
      engagementUrl = _a.engagementUrl,
      isLoading = _a.isLoading,
      reports = _a.reports,
      pageTitle = _a.pageTitle;
  var isEmpty = reports.length === 0;
  var modalClassName = "select-powerbi-file-modal" + (isEmpty ? '-empty' : '');
  return (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal, __assign({
    centered: true,
    className: modalClassName,
    show: show,
    onHide: onHide
  }, {
    children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Header, __assign({
      closeButton: true
    }, {
      children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal.Title, {
        children: [pageTitle(exports.title), (0, jsx_runtime_1.jsx)("p", {
          children: "Select a file to browse its contents"
        }, void 0)]
      }, void 0)
    }), void 0), isLoading && (0, jsx_runtime_1.jsx)(Loader_1.default, {
      dataTestId: "power-bi-reports-loader"
    }, void 0), !isLoading && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "select-powerbi-file-modal__body-header"
      }, {
        children: (0, jsx_runtime_1.jsxs)("div", {
          children: [(0, jsx_runtime_1.jsx)(Icon_1.default, {
            name: "folder-closed",
            width: "22",
            className: "icon outline icon-orange"
          }, void 0), (0, jsx_runtime_1.jsxs)("span", {
            children: [project.name, " workspace"]
          }, void 0), (0, jsx_runtime_1.jsx)("a", __assign({
            className: "external-source-link",
            target: "_blank",
            rel: "noopener noreferrer",
            "data-testid": "project-workbench-link",
            href: engagementUrl + "/reports"
          }, {
            children: (0, jsx_runtime_1.jsx)(Icon_1.default, {
              name: "box-arrow-up-right",
              width: "16",
              className: "icon fill icon-orange"
            }, void 0)
          }), void 0), ' ']
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "select-powerbi-file-modal__body"
      }, {
        children: !isEmpty ? (0, jsx_runtime_1.jsx)("ul", {
          children: reports.map(function (report) {
            return (0, jsx_runtime_1.jsx)("li", {
              children: (0, jsx_runtime_1.jsxs)("button", __assign({
                type: "button",
                onClick: function () {
                  return fileSelected(report);
                },
                className: "ui-button button-link button-theme"
              }, {
                children: [(0, jsx_runtime_1.jsx)(Icon_1.default, {
                  name: "powerbi",
                  width: "22",
                  className: "icon fill icon-orange"
                }, void 0), report.name]
              }), void 0)
            }, report.reportId);
          })
        }, void 0) : (0, jsx_runtime_1.jsxs)("div", __assign({
          "data-testid": "pbi-empty-state-div"
        }, {
          children: [(0, jsx_runtime_1.jsx)(Icon_1.default, {
            name: "alert",
            className: "fill icon-yellow",
            width: 28,
            "data-testid": "draft-icon"
          }, void 0), "There are no Power BI files in this project's workspace"]
        }), void 0)
      }), void 0)]
    }, void 0)]
  }), void 0);
};

exports.SelectPowerBiFileModal = SelectPowerBiFileModal;